<div class="service-chip-selector-container">
  @if (label) {
    <label class="mb-1.5 block text-sm font-medium font-semibold text-gray-700 dark:text-gray-400">
      {{ label }}
      @if (required) {
        <span class="text-error-500">*</span>
      }
    </label>
  }

  <div class="relative">
    <!-- Selected chips -->
    <div
      class="min-h-11 w-full rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 py-2 flex flex-wrap gap-2 items-center cursor-text"
      (click)="onFocus()"
      (focus)="onFocus()"
      (focusout)="onBlur($event)"
      tabindex="0"
      [attr.aria-label]="'Selector de servicios'"
    >
      @if (selectedServices().length === 0) {
        <span class="text-sm text-gray-400 dark:text-gray-500">{{ placeholder }}</span>
      } @else {
        @for (service of selectedServices(); track service.serviceId) {
          <span
            class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-sm font-medium bg-brand-50 dark:bg-brand-500/20 text-brand-700 dark:text-brand-300 border border-brand-200 dark:border-brand-500/30"
          >
            {{ service.name }}
            <button
              type="button"
              (click)="removeService(service); $event.stopPropagation()"
              class="flex items-center justify-center w-4 h-4 rounded-full hover:bg-brand-200 dark:hover:bg-brand-500/40 transition-colors"
              [attr.aria-label]="'Eliminar ' + service.name"
            >
              <svg
                class="w-3 h-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </span>
        }
      }
    </div>

    <!-- Dropdown -->
    @if (isOpen()) {
      <div
        class="fixed inset-0 bg-black/40 z-[9998] animate-[fadeIn_0.2s_ease]"
        (click)="closeDropdown()"
      ></div>
      <div
        class="absolute top-[calc(100%+0.5rem)] left-0 right-0 w-full max-h-96 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg shadow-lg dark:shadow-xl z-[9999] flex flex-col overflow-hidden animate-[slideDown_0.3s_ease]"
        (click)="$event.stopPropagation()"
        (focusout)="onBlur($event)"
      >
        <div class="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50">
          <div class="flex items-center gap-3">
            <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-brand-50 dark:bg-brand-500/10">
              <svg
                class="w-5 h-5 text-brand-500 dark:text-brand-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                />
              </svg>
            </div>
            <div>
              <h3 class="m-0 text-base font-semibold text-gray-900 dark:text-gray-200">
                Seleccionar Servicios
              </h3>
              @if (searchTerm()) {
                <p class="m-0 mt-0.5 text-xs text-gray-500 dark:text-gray-400">
                  {{ filteredServices().length }} {{ filteredServices().length === 1 ? 'resultado' : 'resultados' }}
                </p>
              } @else {
                <p class="m-0 mt-0.5 text-xs text-gray-500 dark:text-gray-400">
                  {{ filteredServices().length }} {{ filteredServices().length === 1 ? 'servicio disponible' : 'servicios disponibles' }}
                </p>
              }
            </div>
          </div>
          <button
            type="button"
            class="flex items-center justify-center w-8 h-8 p-0 bg-transparent border-none rounded-md cursor-pointer text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all"
            (click)="closeDropdown()"
            [attr.aria-label]="'Cerrar'"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div class="p-3 border-b border-gray-200 dark:border-gray-700">
          <input
            #searchInput
            type="text"
            [value]="searchTerm()"
            (input)="onSearchInput($event)"
            (keydown)="onSearchKeyDown($event)"
            (focus)="onFocus()"
            (focusout)="onBlur($event)"
            placeholder="Buscar servicios..."
            class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-700 rounded-md bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-200 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:outline-none focus:border-blue-500 dark:focus:border-blue-500 focus:ring-3 focus:ring-blue-500/10 dark:focus:ring-blue-500/20 transition-colors"
            autocomplete="off"
          />
        </div>

        <div class="flex-1 overflow-y-auto max-h-64 p-0">
          @if (isLoading()) {
            <div class="py-8 px-4 text-center text-gray-500 dark:text-gray-400 text-sm">
              <p>Cargando servicios...</p>
            </div>
          } @else if (filteredServices().length > 0) {
            @for (
              service of filteredServices();
              track service.serviceId;
              let i = $index
            ) {
              <div
                [attr.data-service-index]="i"
                [class.bg-blue-100]="isHighlighted(i)"
                [class.dark:bg-blue-900/30]="isHighlighted(i)"
                [class.border-l-blue-500]="isHighlighted(i)"
                (click)="selectService(service)"
                class="px-4 py-3 cursor-pointer transition-colors border-l-4 border-transparent hover:bg-gray-50 dark:hover:bg-gray-800"
                [attr.aria-selected]="isHighlighted(i)"
                role="option"
              >
                <div class="flex items-start gap-3">
                  <div class="flex-1">
                    <h4 class="m-0 mb-1 text-sm font-medium text-gray-900 dark:text-gray-200">
                      {{ service.name }}
                    </h4>
                    @if (service.description) {
                      <p class="m-0 mb-1 text-xs text-gray-500 dark:text-gray-500 overflow-hidden text-ellipsis line-clamp-2">
                        {{ service.description }}
                      </p>
                    }
                    <div class="flex items-center gap-3 text-xs text-gray-500 dark:text-gray-400">
                      @if (service.durationMinutes) {
                        <span>{{ service.durationMinutes }} min</span>
                      }
                      @if (service.price) {
                        <span>${{ service.price | number:'1.0-2' }}</span>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          } @else {
            <div class="py-8 px-4 text-center text-gray-500 dark:text-gray-400 text-sm">
              <p class="italic">No se encontraron servicios</p>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>

